import React from "react";
import "./style.css";

const NotFound = () => (
  <div>
    <h1>:(</h1>
  </div>
);
export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound/index.js